import React from 'react'

import { IconBase } from '../IconBase'
import { IconProps } from '../types'

export const ChevronSelectorVertical: React.FC<IconProps> = (props) => (
  <IconBase {...props}>
    <path
      d="M7 15L12 20L17 15M7 9L12 4L17 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
)
